export const CREATE_OTHER_DEDUCTION = "CREATE_OTHER_DEDUCTION";
export const FETCH_OTHER_DEDUCTIONS = "FETCH_OTHER_DEDUCTIONS";
export const FETCH_OTHER_DEDUCTION = "FETCH_OTHER_DEDUCTION";
export const EDIT_OTHER_DEDUCTION = "EDIT_OTHER_DEDUCTION";
export const DELETE_OTHER_DEDUCTION = "DELETE_OTHER_DEDUCTION";
export const CLEAR_OTHER_DEDUCTION = "CLEAR_OTHER_DEDUCTION";
